import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { empty } from "rxjs/observable/empty";

import { AgenteService } from "../../services/agente/agente.service";
import { NavbarService } from "../../services/navbar/navbar.service";
import { CotizacionesService } from "./shared/services/cotizaciones.service";
import { RedireccionService } from "../../services/redireccion/redireccion.service";
import { MensajeSnackBarService } from "../../services/mensaje-snack-bar/mensaje-snack-bar.service";

import {
  CotizacionRequest,
  CotizacionRequestBuilder,
} from "../../models/cotizacion/cotizacion-request.model";

import { Paginacion } from "../../models/paginacion/paginacion.model";
import { Filtros } from "../../models/cotizacion/filtros.model";
import { Cotizacion } from "../../models/cotizacion/cotizacion.model";

const SNACK_MSG_POSITION = {
  center: "center",
  top: "top",
  bottom: "bottom",
};

@Injectable()
export class MisNegociosSandbox {
  private totalCotizaciones: number;
  private cotizacionRequest: CotizacionRequest;

  constructor(
    private cotizacionesService: CotizacionesService,
    private redireccionService: RedireccionService,
    private agenteService: AgenteService,
    private navbarService: NavbarService,
    private mensajeSnackBarService: MensajeSnackBarService
  ) {}

  async getCotizaciones(paginacion: Paginacion): Promise<Observable<Cotizacion[]>> {
    let builder = new CotizacionRequestBuilder();
    this.cotizacionRequest = await (await this.addAgent(builder))
      .paginacion(paginacion)
      .build();
    return this.buscarCotizaciones(this.cotizacionRequest);
  }

  getCotizacionesByPage(paginacion: Paginacion): Observable<Cotizacion[]> {
    this.cotizacionRequest.paginacion = paginacion;

    return this.cotizacionesService
      .buscarCotizaciones(this.cotizacionRequest)
      .map((res) => res.cotizaciones);
  }

  async filtrarCotizaciones(filtros: Filtros, paginacion: Paginacion): Promise<Observable<Cotizacion[]>> {
    let builder = new CotizacionRequestBuilder();
    let dniTomador = filtros.tipoDocumento ? filtros.tipoDocumento + filtros.noDocumento: null;

    let desde = filtros.fechaCotizacionDesde ? this.getDesde(filtros.fechaCotizacionDesde) : null
    let hasta = filtros.fechaCotizacionHasta ? this.getHasta(filtros.fechaCotizacionHasta) : null

    let producto = filtros.producto ? filtros.producto : { ramo: null, subramo: null };

    this.cotizacionRequest = await (await this.addAgent(builder))
      .paginacion(paginacion)
      .nroCotizacion(filtros.noCotizacion)
      .dniTomador(dniTomador)
      .cdRamo(producto.ramo)
      .cdSubramo(producto.subramo)
      .fechaCreacionInicio(desde)
      .fechaCreacionFin(hasta)
      .build();
    return this.buscarCotizaciones(this.cotizacionRequest);
  }

  private getDesde(fechaHasta) {
    let fechaSplitted = fechaHasta.split("-");
    let year = fechaSplitted[0];
    let month = --fechaSplitted[1];
    let day = fechaSplitted[2];
    return new Date(Date.UTC(year, month, day, 5, 0, 0)).toISOString();
  }

  private getHasta(fechaDesde) {
    let fechaSplitted = fechaDesde.split("-");
    let year = fechaSplitted[0];
    let month = --fechaSplitted[1]; //months start 0 to 11
    let day = ++fechaSplitted[2];
    return new Date(Date.UTC(year, month, day, 4, 59, 59)).toISOString();
  }

  private buscarCotizaciones(request: CotizacionRequest): Observable<Cotizacion[]> {
    return this.cotizacionesService
      .buscarCotizaciones(request)
      .map((res) => {
        this.totalCotizaciones = res.cotizaciones.length;
        if (this.totalCotizaciones === 0) {
          this.mostrarMensaje("No se encontraron cotizaciones relacionadas al código de asesor seleccionado");
        }
        return res.cotizaciones;
      })
      .catch((error) => {
        this.mostrarMensaje("Ocurrio un ERROR con la aplicación: " + error);
        return empty();
      });
  }

  private async addAgent(requestBuilder: CotizacionRequestBuilder) {
    if (!this.agenteService.getAgente()) {
      await this.agenteService.cargarInformacionAgente();
    }

    let agente = this.agenteService.isPerfilAsesorOADelegado()
      ? this.agenteService.getCodigoAgente().toString()
      : null;

    return requestBuilder
      .cdAgente(agente)
      .cdUsuario(this.agenteService.getUsuarioAgente().toString());
  }

  capturarDetalleNavbar(): Observable<String> {
    if (!this.agenteService.isPerfilAsesorOADelegado()) {
      this.navbarService.setDetalle("aux");
    }
    return this.navbarService.selectedDetalle$;
  }

  redirigir(url: string) {
    this.redireccionService.redireccionNuevaPestana(url);
  }

  validarSarlaft(nroCotizacion: number): Observable<any> {
    return this.cotizacionesService.validarSarlaft(nroCotizacion);
  }

  validarDocumento(nroCotizacion: number): Observable<any> {
    return this.cotizacionesService.consultarDocumentosFirma(nroCotizacion);
  }

  reenviarDocumento(nroDocumento: String): Observable<any> {
    return this.cotizacionesService.reenviarDocumento(nroDocumento);
  }

  mostrarMensaje(mensaje: String, verticalPosition = SNACK_MSG_POSITION.top) {
    this.mensajeSnackBarService.mostrarMensajeWithPosition(
      mensaje,
      SNACK_MSG_POSITION.center,
      verticalPosition
    );
  }

  buscarTiposDocumento(): Observable<any[]> {
    return this.cotizacionesService.buscarTiposDocumento(
      this.agenteService.getCodigoPais(),
      this.agenteService.getgrupoPersona()
    );
  }

  buscarProductos(): Observable<any[]> {
    return this.cotizacionesService.buscarProductos();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/mis-negocios/mis-negocios.sandbox.ts